// Базовый URL вашего PHP API
const API_URL = '/api';

// ==================== ИНТЕРФЕЙСЫ ====================

export interface Review {
    id: number;
    name_reviews: string;
    text_reviews: string;
    image_reviews_base64?: string;
}

export interface Course {
    id: number;
    name: string;
    description: string;
    price: number;
    image?: string;
    duration : number;
    count: number;
    timeLesson: number;
}

export interface Teacher {
    id: number;
    name: string;
    position: string;
    grade?: string;
    positionFull?: string;
    description: string;
    image?: string;
}
export interface ScheduleItem {
    id: number;
    day_of_week: string;
    subject: string;
    time_start: string | null;
    time_end: string | null;
    room: string | null;
    teacher_name: string | null;
}

export const scheduleAPI = {
    getAll: async (): Promise<ScheduleItem[]> => {
        const response = await fetch(`${API_URL}/get_schedule.php`);
        if (!response.ok) throw new Error('Ошибка загрузки расписания');
        return await response.json();
    },

    add: async (formData: FormData): Promise<{success: boolean, id?: number}> => {
        const response = await fetch(`${API_URL}/php/schedule/add_schedule.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при добавлении');
        return await response.json();
    },

    update: async (id: number, formData: FormData): Promise<{success: boolean}> => {
        formData.append('id', id.toString());
        const response = await fetch(`${API_URL}/php/schedule/update_schedule.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при обновлении');
        return await response.json();
    },

    delete: async (id: number): Promise<{success: boolean}> => {
        const formData = new FormData();
        formData.append('id', id.toString());
        const response = await fetch(`${API_URL}/php/schedule/delete_schedule.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при удалении');
        return await response.json();
    },
};
// ==================== REVIEWS API ====================

export const reviewsAPI = {
    // Получить все отзывы
    getAll: async (): Promise<Review[]> => {
        const response = await fetch(`${API_URL}/get_reviews.php`);
        if (!response.ok) throw new Error('Ошибка загрузки отзывов');
        return await response.json();
    },

    // Добавить отзыв
    add: async (formData: FormData): Promise<{success: boolean, id?: number}> => {
        const response = await fetch(`${API_URL}/php/reviews/add_review.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при добавлении отзыва');
        return await response.json();
    },

    // Обновить отзыв
    update: async (id: number, formData: FormData): Promise<{success: boolean}> => {
        formData.append('id', id.toString());
        const response = await fetch(`${API_URL}/php/reviews/update_review.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при обновлении отзыва');
        return await response.json();
    },

    // Удалить отзыв
    delete: async (id: number): Promise<{success: boolean}> => {
        const formData = new FormData();
        formData.append('id', id.toString());

        const response = await fetch(`${API_URL}/php/reviews/delete_review.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при удалении отзыва');
        return await response.json();
    },
};

// ==================== COURSES API ====================

export const coursesAPI = {
    // Получить все курсы
    getAll: async (): Promise<Course[]> => {
        const response = await fetch(`${API_URL}/get_courses.php`);
        if (!response.ok) throw new Error('Ошибка загрузки курсов');
        return await response.json();
    },

    // Добавить курс
    add: async (formData: FormData): Promise<{success: boolean, id?: number}> => {
        const response = await fetch(`${API_URL}/php/courses/add_course.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при добавлении курса');
        return await response.json();
    },

    // Обновить курс
    update: async (id: number, formData: FormData): Promise<{success: boolean}> => {
        formData.append('id', id.toString());
        const response = await fetch(`${API_URL}/php/courses/update_course.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при обновлении курса');
        return await response.json();
    },

    // Удалить курс
    delete: async (id: number): Promise<{success: boolean}> => {
        const formData = new FormData();
        formData.append('id', id.toString());

        const response = await fetch(`${API_URL}/php/courses/delete_course.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при удалении курса');
        return await response.json();
    },
};

// ==================== TEACHERS API ====================

export const teachersAPI = {
    // Получить всех преподавателей
    getAll: async (): Promise<Teacher[]> => {
        const response = await fetch(`${API_URL}/get_teachers.php`);
        if (!response.ok) throw new Error('Ошибка загрузки преподавателей');
        return await response.json();
    },

    // Добавить преподавателя
    add: async (formData: FormData): Promise<{success: boolean, id?: number}> => {
        const response = await fetch(`${API_URL}/php/teachers/add_teacher.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при добавлении преподавателя');
        return await response.json();
    },

    // Обновить преподавателя
    update: async (id: number, formData: FormData): Promise<{success: boolean}> => {
        formData.append('id', id.toString());
        const response = await fetch(`${API_URL}/php/teachers/update_teacher.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при обновлении преподавателя');
        return await response.json();
    },

    // Удалить преподавателя
    delete: async (id: number): Promise<{success: boolean}> => {
        const formData = new FormData();
        formData.append('id', id.toString());

        const response = await fetch(`${API_URL}/php/teachers/delete_teacher.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) throw new Error('Ошибка при удалении преподавателя');
        return await response.json();
    },
};